module.exports = __webpack_public_path__ + "img/loons_05.ea9246f7.png";